import { ApiClient } from '@/lib/apiClient';
import type { CreateOutbound, Outbound } from '@/types/outbound';

export default class OutboundService extends ApiClient<Outbound, CreateOutbound> {

  constructor() {
    super('/v1/outbound', 'number');
  }
}
